var SentAssessmentDetail = /** @class */ (function () {
    function SentAssessmentDetail() {
        this.count = 0;
        this.jobMatchIds = [];
        this.candidateAssessmentIds = [];
    }
    return SentAssessmentDetail;
}());
export { SentAssessmentDetail };
//# sourceMappingURL=sentAssessmentDetail.js.map